import { render, staticRenderFns } from "./action-arguments.vue?vue&type=template&id=6350661b"
import script from "./action-arguments.vue?vue&type=script&lang=js"
export * from "./action-arguments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports